/**
 * English display names for the Danish standard-value stage rows Hasura returns (RTLCA-5294 audit finding
 * 25).
 *
 * Keyed by the STORED label exactly as `StageDefaultEmissionsProvider.mapData` composes it —
 * `${stageDefaultEmission.label} (${stage.label})`, e.g. "Terminalprocesser (A4)" — not by an id, because
 * the row carries no separate English column and adding one is a schema change outside this ticket's
 * scope. Keying on the composed display string is therefore fragile on purpose rather than by accident:
 * rename a row's label on Hasura, or reword the composition in the provider, and the matching entry below
 * silently stops applying instead of erroring. If a row shows up untranslated, check its stored label
 * first — see `calculationTypeCopy.ts`, which takes the same trade for the same reason.
 */
const STANDARD_VALUE_STAGE_NAME_BY_STORED_LABEL: Record<string, string> = {
  "Transport af materiel til og fra byggepladsen (A4)": "Transport of materials to and from the site (A4)",
  "Terminalprocesser (A4)": "Terminal processes (A4)",
  "Transport af overskudsmaterialer (A4)": "Transport of surplus materials (A4)",
  "Bortkørsel af jord, som er affald (A5)": "Removal of excavated soil as waste (A5)",
  "Bortkørsel af byggeaffald (A5)": "Removal of construction waste (A5)",
};

/** English display name for a standard-value stage row, or the stored label unchanged when unmapped. */
export const standardValueStageDisplayNameFor = (storedLabel: string): string =>
  STANDARD_VALUE_STAGE_NAME_BY_STORED_LABEL[storedLabel] ?? storedLabel;
